import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter className="mt-4">
      {/* <div>
        <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          NQL
        </a>
        <span className="ms-1">&copy; 2021.</span>
      </div> */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div>
          <span className="me-2">NQL Admin Dashboard</span>
        </div>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
